/**
 * Cart page extras (sections/pg-main-cart.liquid).
 *
 * <pg-cart-note>: saves the order note with /cart/update.js while the shopper types (debounced),
 * so it survives the section re-rendering after a quantity change and needs no submit button.
 * The note travels to checkout with the cart; partner (wholesale) checkout uses the API instead.
 */
import { PgElement, define, debounce, config } from '@pg/core';

class PgCartNote extends PgElement {
  mount() {
    const { input } = this.refs;
    if (!input) return;
    this.lastSaved = input.value;
    const save = debounce(() => this.#save(input.value), 600);
    input.addEventListener('input', save, { signal: this.signal });
    input.addEventListener('change', () => this.#save(input.value), { signal: this.signal });
  }

  /** @param {string} note */
  async #save(note) {
    if (note === this.lastSaved) return;
    this.lastSaved = note;
    try {
      const response = await fetch(config.routes.cartUpdate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note }),
      });
      if (!response.ok) throw new Error(String(response.status));
      if (this.refs.status) this.refs.status.textContent = this.dataset.saved || '';
    } catch {
      this.lastSaved = undefined;
    }
  }
}

define('pg-cart-note', PgCartNote);
